module.exports = "/_next/static/images/e250e7937c30f4e5ac264f1a8563af7d-pay-xs.png.webp";